import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { RemoveOrUnassignedLocationsRequest } from "../../domain/requests";
import { LocationsRepository } from "../../repositories";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class DeleteUnassignedLocationsUsecase implements UseCase<RemoveOrUnassignedLocationsRequest[], boolean> {
  constructor(private locationRepository: LocationsRepository) {}

  execute(params: RemoveOrUnassignedLocationsRequest[]): Observable<boolean> {
    return this.locationRepository.deleteUnassignedLocations(params);
  }
}